<template>
  <div :class="['common-stepper',disabled ? '__disabled': '']">
    <van-stepper v-model="value" integer :min="min" :max="max" :disabled="disabled" @change="change" @overlimit="overlimit"  />
  </div>
</template>

<script>
export default {
  props: {
    stepperValue: {},
    disabled: {
      type: Boolean,
    },
    min: {
      type: Number,
      default: 1,
    },
    max: {
      type: Number,
    },
    itemIndex: {
      type: Number
    }
  },
  data() {
    return {
      value: '',
    }
  },
  watch: {
    stepperValue(v) {
      this.value = v
    },
    value(v) {
      this.$emit('update:stepperValue', v)
    },
  },
  methods: {
    change(value) {
      this.$emit('stepperChange', value, this.itemIndex)
    },
    overlimit() {
      if (!this.disabled && this.value >= this.max) {
        this.$toast(`最多只能购买${this.max}件哦！`)
      }
    }
  },
}
</script>

<style scoped>
.common-stepper :deep(.van-stepper__plus--disabled) {
  color: #333;
}
.common-stepper.__disabled :deep(.van-stepper__plus--disabled) {
  color: #c8c9cc;
}
.common-stepper :deep(.van-stepper__minus,.common-stepper :deep(.van-stepper__plus,.common-stepper :deep(input))) {
  border-color: #ddd;
}
.common-stepper :deep(button) {
  width: 0.54rem;
  height: 0.48rem;
}
.common-stepper :deep(input) {
  width: 0.64rem;
  height: 0.48rem;
}
.common-stepper :deep(.van-stepper__minus::before,.common-stepper :deep(.van-stepper__plus::before)) {
  width:0.2rem;
}
.common-stepper :deep(.van-stepper__minus::after,.common-stepper :deep(.van-stepper__plus::after)) {
  height: 0.2rem;
}
</style>
